import React, { useState, useRef, useEffect } from 'react';
import { DropdownButton, DropdownContainer, DropdownMenu, DropdownMenuItem } from './styles';
import { ReactComponent as IconMoreVertical } from '../../assets/icons/icon_more_vertical.svg';

interface DropdownMenuProps {
    items: { label: string; onClick: () => void }[];
}

// DropdownMenu component
export const Dropdown = ({ items }: DropdownMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleItemClick = (onClick: () => void) => {
        onClick();
        setIsOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <DropdownContainer ref={dropdownRef}>
            <DropdownButton onClick={toggleDropdown}>
                <IconMoreVertical />
            </DropdownButton>
            {isOpen && (
                <DropdownMenu>
                    {items.map(({ label, onClick }) => (
                        <DropdownMenuItem key={label} onClick={() => handleItemClick(onClick)}>
                            {label}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenu>
            )}
        </DropdownContainer>
    );
};
